/**
 * @generated SignedSource<<7a52af641a715f472a2571381b1dff46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAttachmentsFragment$data = {
  readonly attachments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly confidential: boolean;
        readonly contentLength: number;
        readonly creator: {
          readonly displayName: string;
        } | null;
        readonly id: string;
        readonly name: string;
        readonly uploadUrl: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"AssigneesPreview__node" | "AttachmentUpdater_assignees" | "AttachmentsListWithVersionsFragment">;
      };
    } | null>;
  } | null;
  readonly " $fragmentType": "useAttachmentsFragment";
};
export type useAttachmentsFragment$key = {
  readonly " $data"?: useAttachmentsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAttachmentsFragment">;
};
const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [{
      "count": null,
      "cursor": null,
      "direction": "forward",
      "path": ["attachments"]
    }]
  },
  "name": "useAttachmentsFragment",
  "selections": [{
    "alias": "attachments",
    "args": null,
    "concreteType": "AttachmentConnectionType",
    "kind": "LinkedField",
    "name": "__useAttachmentsFragment_attachments_connection",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "concreteType": "AttachmentConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "Attachment",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentLength",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "_User",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "args": [{
            "kind": "Literal",
            "name": "count",
            "value": 100
          }],
          "kind": "FragmentSpread",
          "name": "AssigneesPreview__node"
        }, {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AttachmentUpdater_assignees"
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "confidential",
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uploadUrl",
          "storageKey": null
        }, {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AttachmentsListWithVersionsFragment"
        }, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "HasAttachments",
  "abstractKey": "__isHasAttachments"
};
(node as any).hash = "ba09774396babbddbef9f2a25bde2257";
export default node;